import RedactText from "../optout-general-components/redacttext";
import Image from "next/image";
import TailwindButton from "src/components/general/tailwindButton";

interface RedactoAdviceProps {
  redactoTitle: string;
  redactoText: string;
  imagePath: string;
  isButtonVisible: boolean;
}

function RedactoAdvice({
  redactoTitle,
  redactoText,
  imagePath,
  isButtonVisible,
}: RedactoAdviceProps) {
  return (
    <div className="flex flex-col-reverse sm:flex-row w-[350px] sm:w-[1210px]">
      <div className="flex flex-col w-full justify-center text-center sm:text-left sm:flex-col">
        <RedactText
          color="text-redactWhite font-bold font-sans sm:w-[550px]"
          size="sm:text-[51px] text-[40px]"
          text={redactoTitle}
        />

        <RedactText
          color="text-gray-300"
          size="text-[16px] mt-10 text-balance"
          text={redactoText}
        />

        {isButtonVisible ? (
          <div className="flex w-full items-end justify-center sm:justify-start mt-5">
            <TailwindButton
              buttonBGColor="bg-brand-slate"
              buttonBorderColor="border-brand-purple"
              buttonHeight="h-[38px]"
              buttonWidth="w-[132px]"
              buttonText="Get Started"
              buttonTextTailwindStyle="font-bold text-[16px]"
              buttonURL="/ai-optout-guide-list"
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="sm:min-w-[600px]">
        <Image
          src={require(`/public/images/aiOptOut/common/${imagePath}`)}
          alt="Redact Logo"
          className=""
          width={600}
          height={0}
          priority
        />
      </div>
    </div>
  );
}

export default RedactoAdvice;
